import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import './assets/style.css'
import { useFormStore } from './stores/formStore'
import { fetchCsrfToken } from './api'

// Fetch CSRF token before initializing the app
// This ensures all API calls have the token available
async function initializeApp() {
  try {
    // Fetch CSRF token from backend
    await fetchCsrfToken()
    console.log('CSRF protection initialized')
  } catch (error) {
    console.warn('Could not fetch CSRF token on startup:', error.message)
    // Continue app initialization even if CSRF fetch fails
    // Token will be fetched on first API call that requires it
  }

  // Creazione dell'istanza dell'app
  const app = createApp(App)

  // Configurazione di Pinia (store)
  const pinia = createPinia()
  app.use(pinia)

  // Configurazione del router
  app.use(router)

  const store = useFormStore()
  store.checkSession()

  // Monta l'app al DOM
  app.mount('#app')
}

// Initialize app with CSRF protection
initializeApp()
